"use client";

import { c as _c } from "react/compiler-runtime";
import { Tab as HeroTab } from "@heroui/react";
import type React from "react";
import { cn } from "../../lib/utils";
export type TabProps = React.ComponentProps<typeof HeroTab> & {
  className?: string;
};

// Create the wrapper component
const TabWrapper = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn(className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <HeroTab {...props} className={t1}>{children}</HeroTab>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};

// Copy all static properties from the original component
Object.setPrototypeOf(TabWrapper, HeroTab);
Object.assign(TabWrapper, HeroTab);

// Ensure the component has the right displayName and type
TabWrapper.displayName = (HeroTab as React.ComponentType<unknown>).displayName || "Tab";

// Copy the $$typeof symbol if it exists
if ("$$typeof" in HeroTab) {
  (TabWrapper as unknown as Record<string, unknown>).$$typeof = (HeroTab as unknown as Record<string, unknown>).$$typeof;
}
export const Tab = TabWrapper;